import React, {useEffect} from "react";
//import { Link } from "gatsby";
import { useLocation } from "@reach/router"
import {isDesktop} from "react-device-detect"

import {Horizontal, MicroCombo} from "@dadoagency/gatsby-plugin-trustpilot-widget";

// const {Mini} = loadable(() =>
//   import("@dadoagency/gatsby-plugin-trustpilot-widget")
// )

const ReviewRatings = (props) => {
    
    const location = useLocation();


    return(
        <div className="ratings">
            {
                (isDesktop ?
                    <Horizontal 
                        language="en"
                        culture="GB"
                        theme="dark"
                        width="100%"
                        //height="110px"
                        stars="5"
                    />
                :
                    <Horizontal 
                        language="en"
                        culture="GB"
                        theme={"light"}
                        width="100%"
                        //height="110px"
                        stars="5"
                    />
                )
            }

            {/* {process.env.GATSBY_SITE_NAME === "Chase Evans" ?
            
                (isDesktop ?
                    <MicroCombo 
                        language="en"
                        culture="GB"
                        theme="dark"
                        width="100%"
                        //height="110px"
                        stars="5"
                    />
                :
                    <MicroCombo 
                        language="en"
                        culture="GB"
                        theme={"light"}
                        width="100%"
                        //height="110px"
                        stars="5"
                    />
                )

            :
                (isDesktop ?
                    <Horizontal 
                        language="en"
                        culture="GB"
                        theme="dark"
                        width="100%"
                        //height="110px"
                        stars="5"
                    />
                :
                    <Horizontal 
                        language="en"
                        culture="GB"
                        theme={"light"}
                        width="100%"
                        //height="110px"
                        stars="5"
                    />
                )
            } */}

        </div>
    )
}
export default ReviewRatings;